

































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { UserPermissions } from "@/types/store";
import { GenericReferral, ReferralType } from "@/types/types";
import ReferralIcon from "@/components/ReferralIcon.vue";
import ArrivalProgressBar from "@/components/referral/ArrivalProgressBar.vue";
import { decodeVehicleNumber } from "@/services/vehicleNumberDecoder";
import { Configuration } from "@/services/Configuration";

@Component({
  components: {
    "referral-icon": ReferralIcon,
    "arrival-progress-bar": ArrivalProgressBar,
  },
})
export default class Referral extends Vue {
  @Prop({ default: null })
  item!: GenericReferral;

  @Prop({ default: false })
  enableResolve!: boolean;

  @Prop({ default: false })
  enableLinkPatient!: boolean;

  @Getter("userPermissions")
  userPermissions!: UserPermissions;

  @Prop({ default: false })
  showArrivalBar!: boolean;

  formatDate = Vue.filter("formatDate");

  get isPatientTransporterView(): boolean {
    return this.userPermissions.patientTransporterView;
  }

  get isResolveAllowed(): boolean {
    return this.enableResolve && this.item.state != "RESOLVED";
  }

  get isLinkPatientAllowed(): boolean {
    return this.item.patientNumber == null && this.enableLinkPatient;
  }

  get isContextMenuEnabled(): boolean {
    return (
      (this.isResolveAllowed || this.isLinkPatientAllowed) &&
      !this.isPatientTransporterView
    );
  }

  get faAmbulanceIdIcon(): string {
    const ambulanceId = this.item.ambulanceId;
    if (!ambulanceId) return "";

    const { vehicle, specialCase } = decodeVehicleNumber(ambulanceId);
    const isHelicopter = vehicle === "MMT" && specialCase === "Helikopter";

    return isHelicopter ? "fa fa-helicopter" : "fa fa-ambulance";
  }

  get showArrivalProgress(): boolean {
    return (
      Configuration.showArrivalFeatures &&
      this.showArrivalBar &&
      this.item.type === ReferralType.ESPOED &&
      !!this.item.ambulanceId &&
      !this.item.isCancelled &&
      this.item.state !== "RESOLVED" &&
      !!this.item.etaDate &&
      !!this.item.etaTime
    );
  }

  clickedReferralRow(): void {
    this.$emit("clicked", this.item);
  }

  clickedLinkPatientButton(): void {
    this.$emit("clickedLinkPatient", this.item);
  }

  clickedResolveButton(): void {
    this.$emit("clickedResolve", this.item);
  }

  ambuFeedbackClick(e: Event): void {
    this.$emit("clickedAmbuFeedback", this.item);
  }
}
